import { useQuery } from '@tanstack/react-query';
import { axiosPrivate } from 'app/utils';

export interface Page {
  id: string;
  name: string;
  href: string;
}

export interface PagesResponse {
  pages: Page[];
  pagination: {
    total: number;
    currentPage: number;
  };
}

export const pagesQueryKey = (websiteId: string) => ['plus-website-pages', websiteId] as const;

async function fetchPages(websiteId: string) {
  const { data } = await axiosPrivate.get<PagesResponse>(
    `/v3/pharmacist/plus-websites/${websiteId}/versions/preview/pages`
  );
  return data;
}

interface UseGetPagesResult {
  pages: Page[];
  pagination: PagesResponse['pagination'] | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export function useGetPages({ websiteId }: { websiteId: string }): UseGetPagesResult {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: pagesQueryKey(websiteId),
    queryFn: () => fetchPages(websiteId),
    enabled: !!websiteId,
    meta: { errorMessage: 'Failed to load pages' },
  });

  return {
    pages: data?.pages ?? [],
    pagination: data?.pagination,
    isLoading,
    isError,
    error,
  };
}
